// chart-cursor.js

export const INITIAL_STATE = {
  active: false,
  timestamp: null,
};

// action types
const SET_CHART_CURSOR = "trace-web/chart-cursor/SET_CURSOR";

// action creators
export const setChartCursor = timestamp => {
  return {
    type: SET_CHART_CURSOR,
    timestamp,
  };
};

// reducer
const chartCursorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CHART_CURSOR:
      return {
        ...state,
        active: !!action.timestamp || action.timestamp === 0,
        timestamp: action.timestamp,
      };
    default:
      return state;
  }
};
export default chartCursorReducer;
